/* vue.js ie에서 보이도록 처리 */
import "es6-promise/auto";
import "@babel/polyfill";

import Vue from "vue";
import App from "./App";

/* Router */
import { router } from "./router";

/* vuex in store Module */
import { store } from "./js/store/store";

/* Axios (version : 0.19.2) */
import Axios from "axios";

/* Lodash ( version : 4.17.15 ) */
//import Lodash from "lodash";

// 퍼블 주석 처리, css 충돌방지 / vuetify 적용예정

/*---------------- 퍼블 추가 ----------------*/
//import "./assets/css/common.css";
//import "./assets/css/cooperation.css";

// vue-swatches Import the styles too, globally
import "vue-swatches/dist/vue-swatches.css";

/*---------------- 퍼블 추가 S ----------------*/
import "./assets/css/fonts.css";
import "./assets/css/reset.css";
import "./assets/css/swiper-bundle.min.css"; //VueAwesomeSwiper
import "./assets/css/common.css";
import "./assets/css/components.css";
import "./assets/css/main.css";
import "./assets/css/mypage.css";
import "./assets/css/history.css";
import "./assets/css/board.css";
import "./assets/css/common_hgisp.css";

// 추후 적용예정
// import "./assets/css/animate.css";
/*---------------- //퍼블 추가 ----------------*/

/* vue-js-modal ( version : 1.3.33 ) */
import VueJsModal from "vue-js-modal";

/* vee validator ( version : 2.2.15 ) */
import validator from "./js/store/modules/validation";

/* vue-tree-list ( version : 2.1.6 ) */
//import VJstree from "vue-jstree";

/* moment ( version :  ) */
import Moment from "moment";
//Vue.use("moment", Moment);

/* v-click-outside ( version : 3.0.1 ) */
import vClickOutside from "v-click-outside";

/* vue-drag-drop ( version : 1.1.4 ) */
import VueDragDrop from "vue-drag-drop";

/* vue-toasted ( version : 1.1.27 ) */
import Toasted from "vue-toasted";

/* vuetify ( version : 2.2.19 ) */
import Vuetify from "vuetify";
//import "vuetify/dist/vuetify.min.css";

/* vue-sse (version : 1.0.2) */
//import VueSSE from "vue-sse";
//Vue.use(VueSSE);

/* vue-i18n (version : 8.21.0) */
import i18n from "./locales/I18n";
import i18nUtil from "./locales/I18nUtil"
Vue.prototype.$i18nUtil = i18nUtil;

/* 이모티콘 function */
import emoticonFn from "./js/emoticon/emoticon"
Vue.prototype.$emoticonFn = emoticonFn;

/* global method confirm/alert dialog call */
/* Vue.prototype.showConfirmDialog / Vue.prototype.showAlertDialog */
import confirmDialog from "./js/store/module/common/confirmDialog";

/* Vue.prototype.convertDateDotYMD */
import convertDateFormat from "./js/store/module/common/convertDateFormat";

/* byte check function js */
import byteFunction from "./js/store/module/common/byteFunction";

/* new window popup function js */
import newWindowFunction from "./js/store/module/common/newWindowFunction";

/* new window popup function js */
import showLoadingbarFunction from "./js/store/module/common/showLoadingbarFunction";

/* sso function js */
import hli_ssoutil from "./js/store/module/sso/hli_ssoutil";

/* vue-loading-overlay(version : 3.4.2) */
import Loading from "vue-loading-overlay";
import 'vue-loading-overlay/dist/vue-loading.css';
Vue.use(Loading, {
  opacity : 0.4,    /* background 밝기 */
  loader : 'dots',  /* 스타일(dots/spinner/bars) */
  color : 'black',  /* progressBar color */
  canCancel: false, /* 화면 클릭 시, progressBar 사라짐(true/false) */
  backgroundColor: 'black', /* 배경 색상 */
});

const vuetifyOptions = {};

Vue.config.productionTip = false;
window.EventBus = new Vue();

/* axios 전역으로 사용될수 있도록 설정 */
Vue.prototype.$axios = Axios;
Vue.prototype.$moment = Moment;

/* tooltip 말줄임 여부 check 전역 등록 */
import tooltip from '@/components/cowork/common/tooltip/tooltip';
Vue.prototype.$tooltip = tooltip;

/* Vue.use(component or lib) */
Vue.use(Vuetify);
Vue.use(Toasted);
//Vue.use(VJstree);
//Vue.use(VueMaterial);
Vue.use(VueDragDrop);
Vue.use(vClickOutside);
Vue.use(VueJsModal, {
  dialog: true,
  dynamic: true,
  injectModalsContainer: true,
  dynamicDefaults: {
    clickToClose: false,
    scrollable : true
  }
});
Vue.use(confirmDialog);
Vue.use(convertDateFormat);
Vue.use(byteFunction);
Vue.use(newWindowFunction);
Vue.use(showLoadingbarFunction);
Vue.use(hli_ssoutil);

new Vue({
  el: "#app",
  router,
  store,
  i18n,
  components: {
    App
  },
  template: "<App/>",
  vuetify: new Vuetify(vuetifyOptions)
});



// WEBPACK FOOTER //
// ./src/main.js